module.exports = __webpack_public_path__ + "static/media/Thumbnail_3.bc4fc778.png";